// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__1lURq","column":"style_column__2yrZX","row":"style_row__1BZvc"};